import BaseModal from 'ext-ui/components/BaseModal/BaseModal'
import Button from 'ext-ui/components/Button/Button'
import TextInput from 'ext-ui/components/TextInput/TextInput'
import React, { useState } from 'react'
import { useTranslate } from 'src/localization/Trns'

import styles from './NormalizedMerchantFeedbackModal.style'

interface NormalizedMerchantFeedbackModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (feedback: string) => void
  normalizedMerchantName: string
  originalMerchantName: string
}

const NormalizedMerchantFeedbackModal: React.FC<
  NormalizedMerchantFeedbackModalProps
> = ({
  isOpen,
  onClose,
  onSubmit,
  normalizedMerchantName,
  originalMerchantName,
}) => {
  const translate = useTranslate()
  const [feedback, setFeedback] = useState('')
  const [error, setError] = useState<string>('')

  const handleSubmit = () => {
    if (!feedback.trim()) {
      setError(translate('Please provide your feedback'))
      return
    }

    onSubmit(feedback.trim())
    setFeedback('')
    setError('')
    onClose()
  }

  const handleClose = () => {
    setFeedback('')
    setError('')
    onClose()
  }

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      variant="interactive"
      className="NormalizedMerchantFeedbackModal"
      aria-label={translate('Normalized Merchant Feedback Modal')}
    >
      <div css={styles} className="NormalizedMerchantFeedbackModal">
        <div className="modal-header">
          <div className="modal-title">
            {translate('Help us improve this match')}
          </div>
        </div>

        <div className="modal-body">
          <p className="modal-subtitle">
            {translate(
              'We changed "${originalName}" to "${normalizedName}". What did you expect instead?',
              {
                originalName: originalMerchantName,
                normalizedName: normalizedMerchantName,
              },
            )}
          </p>
          <TextInput
            placeholder={translate('Tell us what you expected')}
            value={feedback}
            onChange={(e) => {
              setFeedback(e.target.value)
              if (error) setError('')
            }}
            errorText={error}
            variant="medium"
            testId="normalized-merchant-feedback"
          />
        </div>

        <div className="modal-footer">
          <Button
            variant="secondary"
            onClick={handleClose}
            testId="feedback-cancel"
          >
            {translate('Cancel')}
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            testId="feedback-submit"
          >
            {translate('Submit')}
          </Button>
        </div>
      </div>
    </BaseModal>
  )
}

export default NormalizedMerchantFeedbackModal
